import { ReactNode, Suspense, lazy } from 'react';

const Eruda = lazy(() =>
    import('./eruda-provider').then((c) => ({ default: c.Eruda }))
);

export const ErudaProvider = (props: { children: ReactNode }) => {
    if (
        import.meta.env.MODE === 'staging' ||
        import.meta.env.MODE === 'development'
    ) {
        return (
            <Suspense fallback={<div></div>}>
                <Eruda>{props.children}</Eruda>
            </Suspense>
        );
    }

    return props.children;
};
